"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ColorSelector = function ColorSelector(_ref) {
  var canvas = _ref.canvas,
    type = _ref.type,
    setRgba = _ref.setRgba,
    rgba = _ref.rgba,
    setHexCode = _ref.setHexCode,
    onChange = _ref.onChange,
    filledCanvasRef = _ref.filledCanvasRef,
    hexCode = _ref.hexCode,
    noColor = _ref.noColor;
  var selectorClass;
  var startX = 0;
  var startY = 0;
  var updatedX = 0;
  var updatedY = 0;
  var handleMouseMove = function handleMouseMove(e, className) {
    if (noColor) return;
    e.preventDefault();
    var selector;
    startX = e.clientX;
    startY = e.clientY;
    selectorClass = className;
    selector = document.querySelector(".".concat(className));
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  var handleMove = function handleMove(e) {
    updatedX = startX - e.clientX;
    updatedY = startY - e.clientY;
    startX = e.clientX;
    startY = e.clientY;
    var totalTop = document.querySelector(".".concat(selectorClass)).offsetTop - updatedY;
    var totalLeft = document.querySelector(".".concat(selectorClass)).offsetLeft - updatedX;
    if (selectorClass === "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector")) {
      totalTop = 0;
    }
    var isMove = preventMouseMove(e, totalLeft, totalTop);
    if (isMove) {
      (0, _Utils.setColorSelector)(totalLeft, totalTop, type);
      updateStateValues();
      if (selectorClass === "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector")) {
        var rgbValue = (0, _Utils.returnRgbFromCanvas)(totalLeft, totalTop, (0, _Utils.getContext2D)(canvas));
        (0, _Utils.generateColors)((0, _Utils.getContext2D)(filledCanvasRef), filledCanvasRef.current, rgbValue.rgbString);
        (0, _Utils.updateRangeSelectorColor)(totalLeft, noColor);
      }
    }
  };
  var updateStateValues = function updateStateValues() {
    var filledSelector = document.querySelector(".".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector"));
    var top = parseInt(filledSelector.style.top);
    var left = parseInt(filledSelector.style.left);
    var rgbValue = (0, _Utils.returnRgbFromCanvas)(left, top, (0, _Utils.getContext2D)(filledCanvasRef));
    var r = rgbValue.r,
      g = rgbValue.g,
      b = rgbValue.b;
    var hexCode = (0, _Utils.rgbToHex)(r, g, b);
    setRgba(_objectSpread(_objectSpread({}, rgba), {}, {
      r: r,
      g: g,
      b: b
    }));
    setHexCode(hexCode.rgbString);
    var finalColor = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat((0, _Utils.calculateOpacity)(rgba.alpha), ")");
    onChange(finalColor);
  };
  var handleMouseUp = function handleMouseUp() {
    document.removeEventListener("mousemove", handleMove);
  };
  var preventMouseMove = function preventMouseMove(e, left, top) {
    var isMove = true;
    if (selectorClass === "".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector")) {
      if (left < 0 || left >= _Utils.CANVAS_WIDTH) {
        isMove = false;
      } else if (top < 0 || top > _Utils.CANVAS_HEIGHT) {
        isMove = false;
      }
    } else {
      if (left < 0 || left > _Utils.RANGE_CANVAS_WIDTH) {
        isMove = false;
      }
    }
    return isMove;
  };
  if (type === "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector")) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_Utils.PREFIX_CLASSNAME, "-selector ").concat(_Utils.PREFIX_CLASSNAME, "-range-selector ").concat(noColor ? "".concat(_Utils.PREFIX_CLASSNAME, "-disable") : "", " "),
      style: {
        left: 0,
        top: 0,
        background: "".concat(noColor && "#333")
      },
      onMouseDown: function onMouseDown(e) {
        return handleMouseMove(e, "".concat(_Utils.PREFIX_CLASSNAME, "-range-selector"));
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-selector ").concat(_Utils.PREFIX_CLASSNAME, "-filled-selector"),
    style: {
      top: 0,
      left: 0,
      display: "".concat(noColor ? "none" : "block")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: hexCode
    },
    className: "selector ".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector-ring"),
    onMouseDown: function onMouseDown(e) {
      return handleMouseMove(e, "".concat(_Utils.PREFIX_CLASSNAME, "-filled-selector"));
    }
  }));
};
var _default = ColorSelector;
exports.default = _default;